﻿'use strict';

angular.module('ntmApp').factory('ColumnPreferencesCustomizer', [function () {

    var customizer = {};

    customizer.buildOptions = function (preferences, gridOptions) {

        if (preferences) {

            var preoferencesObj = JSON.parse(preferences);

            gridOptions.columnDefs.forEach(function (columnDef) {

                if (preoferencesObj.hasOwnProperty(columnDef.name)) {
                    columnDef.visible = preoferencesObj[columnDef.name];
                }
            });
        }

        return gridOptions;
    };


    return customizer;

}]);